const createActionCreator = actionType => payload => ({
  payload,
  type: actionType,
});
const handleActions = (handlers, initialState) => (state = initialState, action) => (handlers[action.type] ? handlers[action.type](state, { payload: action.payload }) : state);
export {
  createActionCreator,
  handleActions,
};
